import { PageId } from 'constants/pages'
import { getHasBasicSubscription } from 'helpers/getHasBasicSubscription'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'
import type { TStep } from 'src/types'
import { useZustandGlobalStore } from 'zustandGlobalStore'

// Paid and registered intl_d60 users resume on the LearnWorlds redirect page
// instead of the report page that follows it, even after they already left for
// the platform once.
export const getIntellioD60ResumeTarget = (pages: TStep[]): PageId => {
  const resumeTarget = getIntellioResumeTarget({
    pages,
    pageIds: {
      certificate: PageId.CERTIFICATE_INTL_D60,
      nameEntry: PageId.NAME_ENTRY_INTL_D60,
      offer: PageId.OFFER_INTL_D60,
      registration: PageId.REGISTRATION_INTL_D60,
      report: PageId.REPORT_INTL_D60,
    },
  })

  if (resumeTarget !== PageId.REPORT_INTL_D60) return resumeTarget

  const { lead } = useZustandGlobalStore.getState()
  const hasSubscription = getHasBasicSubscription(lead?.subscriptions || null)
  const hasAccount = !!lead?.firebaseToken

  return hasSubscription && hasAccount
    ? PageId.LEARNWORLDS_REDIRECT_INTL_D60
    : resumeTarget
}
